import { RentCollectionStatus, RentCollectionStatusGroups } from '../entity'

export const findGroupNameByStatus = <T>(statuses: RentCollectionStatus[]) => {
  const matching = Object.entries(RentCollectionStatusGroups).find(([_, statusGroup]) => {
    return statusGroup.length === statuses.length && statusGroup.every((g) => statuses.includes(g))
  })
  return matching?.[0] as T
}
